import React, { useEffect, useMemo, useState } from 'react';
import { useAvContext } from './AvContextProvider';

export interface SearchContextValue {
  searchContext: Record<string, any>;
  setSearchContext: React.Dispatch<React.SetStateAction<Record<string, any>>>;
}

export const SearchContext = React.createContext<SearchContextValue>({
  searchContext: {},
  setSearchContext: () => {},
});

function SearchContextProvider({ children }: React.PropsWithChildren = {}) {
  const [searchContext, setSearchContext] = useState({});
  const { accountId } = useAvContext();

  useEffect(() => {
    setSearchContext({});
  }, [accountId]);

  const value = useMemo(() => ({ searchContext, setSearchContext }), [searchContext]);

  return <SearchContext.Provider value={value}>{children}</SearchContext.Provider>;
}

export default SearchContextProvider;
